import {
    REQUEST_SUBSCRIPTION_STATUS,
    REQUEST_SUBSCRIPTION_STATUS_FAILED,
    RECEIVE_SUBSCRIPTION_STATUS
} from '../../../actions/truckLoadRate/admin/subscriptionActions';
import { SubscriptionStatus } from '../../../../interfaces/truckLoadRateServiceInterfaces';

interface SubscriptionStatusState {
    subscriptionStatus?: SubscriptionStatus;
    isFetchingSubscriptionStatus: boolean;
}

const subscriptionStatusInitialState: SubscriptionStatusState = {
    subscriptionStatus: undefined,
    isFetchingSubscriptionStatus: false
};

const subscriptionStatusReducer = (subscriptionStatusState: SubscriptionStatusState = subscriptionStatusInitialState, action: any): SubscriptionStatusState => {
    switch (action.type) {
        case REQUEST_SUBSCRIPTION_STATUS: {
            return {
                ...subscriptionStatusState,
                subscriptionStatus: undefined,
                isFetchingSubscriptionStatus: true
            };
        }
        case REQUEST_SUBSCRIPTION_STATUS_FAILED: {
            return {
                ...subscriptionStatusState,
                subscriptionStatus: undefined,
                isFetchingSubscriptionStatus: false
            };
        }
        case RECEIVE_SUBSCRIPTION_STATUS: {
            return {
                ...subscriptionStatusState,
                subscriptionStatus: action.payload,
                isFetchingSubscriptionStatus: false
            };
        }
        default:
            return subscriptionStatusState;
    }
};

export default subscriptionStatusReducer;
